// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterItem component
 */
!(function() {
  var FILTER_CONTROL_CLASS = 'filter-control';

  var CONSTANTS = require('logic/data/Izenda.ReportDesignerConstants');

  var m = require('mobx');
  var compose = require('recompose').compose;

  var observer = require('mobx-react').observer;
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var classHelper = require('dom-helpers/class');
  var LayoutUtils = require('share/utils/Izenda.LayoutUtils');

  var Input = require('share/components/controls/Izenda.Input');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var QuerySourceDropDown = Validator()(require('./Izenda.QuerySourceDropDown'));
  var DropDown = Validator()(require('share/components/controls/Izenda.DropDown'));
  var ReportDesignerWidget = require('share/components/hoc/Izenda.ReportDesignerWidget');
  const { get, filter, concat } = require('lodash/fp');

  var FilterItem = observer(
    React.createClass({
      propTypes: {
        store: React.PropTypes.object.isRequired,
        itemData: React.PropTypes.object.isRequired,
        showPosition: React.PropTypes.bool.isRequired
      },

      componentDidUpdate: function() {
        // Reset style filter item when hover out container
        const { isOverContainer, itemData } = this.props;
        if (isOverContainer === false && itemData.filterItemDom) {
          itemData.filterItemDom.removeAttribute('style');
        }
      },

      setFilterDom: function(domElement) {
        this.props.itemData.filterItemDom = domElement;
      },

      render: function() {
        var props = this.props;
        var store = props.store;
        var field = props.itemData;
        var showPosition = props.showPosition;
        var reportFilters = store.reportFilters || {};
        var reportBody = store.reportBody || {};
        var aggregatedFields = reportBody.aggregatedFields || [];
        var filtersCommonData = reportFilters.commonData || {};
        var isVisible = field.sourceFieldVisible && field.sourceFieldFilterable;

        var renderFailIcon = function() {
          if (isVisible) {
            return null;
          }
          return <span className="icon-attention fail-color" title={CONSTANTS.BUNDLE.TOOLTIP.FILTER.M07} />;
        };

        var querySource = filtersCommonData.querySource || [];
        var options = concat(
          m.toJS(filter({ isRunningField: false, isCompositeField: false }, querySource)),
          aggregatedFields
        );
        var parameterOptions = [{ value: field.sourceFieldName, label: field.sourceFieldName }];
        var isParameter = field.isParameter;
        return (
          <div
            className="filter-wrapper"
            onMouseDown={this.onClickFilter}
            onTouchStart={this.onClickFilter}
            ref={this.setFilterDom}
          >
            <div className="filter-control">
              <span className="filter-position">{showPosition ? field.position : ''}</span>
              {isParameter ? (
                <div>
                  <DropDown
                    disabled
                    options={parameterOptions}
                    value={field.sourceFieldName}
                    maskedHidden={!(field.sourceFieldVisible && field.sourceFieldFilterable)}
                    validations={CONSTANTS.REQUIRED_CONSTRAINT}
                    field={'Filters' + field.uniqueId}
                  />
                </div>
              ) : (
                <QuerySourceDropDown
                  options={options}
                  disabled={!isVisible}
                  filter={field}
                  value={field.getFilterId()}
                  validations={CONSTANTS.REQUIRED_CONSTRAINT}
                  field={'Filters' + field.uniqueId}
                  reportFilters={reportFilters}
                />
              )}

              {renderFailIcon()}
              {isParameter ? null : (
                <a
                  className="icon-cancel remove-filter"
                  onMouseDown={this.removeFilterItem}
                  onTouchStart={this.removeFilterItem}
                />
              )}
            </div>
          </div>
        );
      },

      removeFilterItem: function(e) {
        e.preventDefault();
        e.stopPropagation();
        var props = this.props;
        var store = props.store;
        var field = props.itemData;
        var reportFilters = store.reportFilters || {};

        if (field.isParameter) {
          return props.confirmFn('Error', {
            description: CONSTANTS.CANNOT_DELETE_PARAM_SP,
            showCancel: false
          });
        }

        store.updateReportDesignerCascadingFilter(field);
        reportFilters.removeFilter && reportFilters.removeFilter(field);
        store.reportFilters.setConfigModeToField(null);
        props.validation.validate();
      },

      onClickFilter: m.action(function(e) {
        var props = this.props;

        if (classHelper.hasClass(e.target.className, 'remove-filter')) {
          return this.removeFilterItem(e);
        }

        if (e.target.className.indexOf('izenda-Dropdown') > -1) {
          return;
        }

        LayoutUtils.togglePropertiesEditor(true);
        props.onClick && props.onClick(arguments);
      })
    })
  );

  var FilterItemContainer = observer(function(props) {
    var field = props.itemData;
    var classes = classnames(props.className, 'u_noPaddingAll', {
      'selected-filter-item': props.isRegistedItem && isConfigField()
    });

    return (
      <GridLayout.Col className={classes} cols="3">
        <FilterItem {...props} checkRegistedItem={isConfigField} />
      </GridLayout.Col>
    );

    function isConfigField() {
      return props.itemData === get('reportFilters.configField.fieldDetails', props.store);
    }
  });

  module.exports = ReportDesignerWidget.wrapper(FilterItemContainer);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.FilterItem.jsx